<template>
    <div class="container-fluid">
        <div class="page-title">
            <h4>Tableau de bord</h4>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <!-- Si on est abonné -->
                    <div class="card-block"  v-if="!showSubscriptionPopup" key="showSubscriptionPopup">
                        <h1 class="card-title">Bienvenue dans Kemtag Manager <br>
                            <small>Quelques liens pour vous aider à commencer</small>
                        </h1>
                        <div class="row mrg-top-40">
                            <!--<div class="col-md-6">
                                <h4>Compteurs</h4>
                                <form class="form-horizontal mrg-top-20">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <div class="form-group">
                                                <label>Importer une commande de compteur</label>
                                                <input type="text" class="form-control" id="form-1-1" placeholder="Code de commande">
                                            </div>
                                        </div>
                                        <div class="col-md-4 mrg-top-30">
                                            <button class="btn btn-primary">Importer</button>
                                        </div>
                                    </div>
                                </form>
                            </div>-->
                            <div class="col-md-4">
                                <h4>Information structure</h4>
                                <ul class="list list-unstyled mrg-top-20">
                                    <li>
                                        Date de fin d'abonnement : {{ formatDate(structure[0].contract_ending_date) }}
                                    </li>
                                    <li>
                                        Nombre de compteurs : {{ sensors.length }}
                                    </li>
                                    <li>
                                        Nombre de plaques SMS : {{ plates.length }}
                                    </li>
                                </ul>
                            </div>
                            <div class="col">
                                <h4>Outils</h4>
                                <ul class="list list-unstyled mrg-top-20">
                                    <li>
                                         <b-link href="Exemple_liste_outil.xls" download>
                                            <i class="ti-download"></i>
                                            Télécharger un exemple de liste d'outils
                                        </b-link>
                                    </li>
                                    <li>
                                        <router-link to="/systems/import">
                                            <i class="ti-import"></i>
                                            Importer une liste d'outils
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/systems/add">
                                            <i class="ti-plus"></i>
                                            Ajouter un outil
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="col">
                                <h4>Utilisateurs </h4>
                                <ul class="list list-unstyled mrg-top-20">
                                    <li>
                                          <b-link href="Exemple_liste_adherent.xls" download>
                                            <i class="ti-download"></i>
                                            Télécharger un exemple de liste d'utilisateurs
                                        </b-link>
                                    </li>
                                    <li>
                                        <router-link to="/adherents/import">
                                            <i class="ti-import"></i>
                                            Importer une liste d'utilisateurs
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/adherents/add">
                                            <i class="ti-plus"></i>
                                            Ajouter un utilisateur
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <!-- Si on est pas abonné -->
                    <div class="card-block"  v-if="showSubscriptionPopup" key="showSubscriptionPopup">
                        <h1 class="card-title">Bienvenue dans Kemtag Manager <br>
                            <small>Vous n'êtes pas actuellement abonné, vous n'avez donc pas accès à la gestion de flotte</small>
                        </h1>
                        <div class="row mrg-top-40">
                            <div class="col">
                                <h4>Fonctionnalité disponible</h4>
                                <ul class="list list-unstyled mrg-top-20">
                                    <li>
                                        <router-link to="/sensors/index">
                                            <i class="ti-import"></i>
                                            Accéder à mes compteurs
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-block"  >
                        <h1 class="card-title">Une question, un contact <br>
                            <small>Pour toutes questions relatives à l'utilisation des produits Kemtag, consultez la notice ou contactez nous :</small>
                        </h1>
                        <div class="row mrg-top-40">
                            <div class="col">
                                <h4>Notice</h4>
                                <ul class="list list-unstyled mrg-top-20">
                                    <li>
                                        <a href="https://kemtag.fr/wp-content/uploads/2021/11/Guide-utilisation-Kemtag.pdf"  target="_blank" rel="noreferrer">
                                     <!--   @click.prevent="downloadItem('https://kemtag.fr/wp-content/uploads/2021/11/Guide-utilisation-Kemtag.pdf','Guide utilisation Kemtag.pdf')" download>-->
                                            <i class="ti-download"></i>
                                            Télécharger la notice
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col">
                                <h4>Par mail</h4>
                                <ul class="list list-unstyled mrg-top-20">
                                    <li>
                                        <a href = "mailto: contact@kemtag.fr">contact@kemtag.fr</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col">
                                <h4>Par téléphone</h4>
                                <ul class="list list-unstyled mrg-top-20">
                                    <li>
                                        <a href="tel:+33230966909">02 30 96 69 09</a>
                                    </li>
                                </ul>
                            </div>  
                        </div>  
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import api from "../config/_api";
    import {isSubscriptionValid} from '../store/modules/auth';
    import download from 'downloadjs';
    export default {
        name: "Dashboard",
        
        computed: {
            ...mapGetters({
                structure: 'structure/structure',
                sensors: 'sensors/sensors',
                plates: 'plates/plates',
            }),
        },
        created(){
            if(this.showSubscriptionPopup == isSubscriptionValid()){
                this.showSubscriptionPopup = !isSubscriptionValid();
                window.location.reload();
            }
        },
        mounted() {
            this.$store.dispatch('structure/getStructure');
            this.$store.dispatch('sensors/getSensors');
            this.$store.dispatch('plates/getPlates');
        },
        props: {
            showSubscriptionPopup: {
                type: Boolean,
                required: true
            }
        },
        methods:{
            change_cloture_date(struct){
                let url = api.url + 'structures/cloture/' + struct.id + '/' + '?clotureDate=' + struct.cloture_exercice;

                let data = {
                    cloture_exercice: struct.cloture_exercice,
                };

                this.axios({url: url, data: data, method: 'POST' })
                    .then(resp => {
                        if(resp.status <400){
                            //
                        }
                    })
                    .catch(err => {
                       //console.log(err);
                    });
            },
            downloadItem ( url, label ) {
                this.axios.get(url, {
                      //  headers: this.headers,
                        responseType: 'blob', // had to add this one here
                    })
                .then(response => {
                   /* const blob = new Blob([response.data], { type: 'application/pdf' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = label;
                    link.click();
                    URL.revokeObjectURL(link.href)*/ //Cette méthode fonctionne mais corromp le fichier, peut-être marche-t-ell pour des fichiers plus simple que des pdf
                    const content = response.headers['content-type'];
                    download(response.data, label, content)
                }).catch(console.error)
            },
            formatDate: function(date){
                var d = new Date(date),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = '' + d.getFullYear();

                //console.log("Date_to_format "+d)
                if (month.length < 2) 
                    month = '0' + month;
                if (day.length < 2) 
                    day = '0' + day;

                return [year, month, day].join('-');
            }
        }
    }

 </script>
